export const COUNTRIES = ['MX', 'BR', 'CL']
export const RECURRENCES = ['none', 'monthly', 'yearly']
export const YEARLY_GROUP = 'yearly'

const LOCALES = { es: 'es-MX', pt: 'pt-BR' }

const byStart = (a, b) => (a.starts_on < b.starts_on ? -1 : a.starts_on > b.starts_on ? 1 : 0)

// One-off and monthly campaigns belong to the year they start in (newest year first); yearly ones (Navidad) repeat
// every year, so they get their own last group instead of the year of the row.
export const groupByYear = seasons => {
  const yearly = seasons.filter(s => s.recurrence === 'yearly').sort(byStart)
  const byYear = seasons
    .filter(s => s.recurrence !== 'yearly')
    .reduce((acc, s) => {
      const year = s.starts_on.slice(0, 4)
      ;(acc[year] = acc[year] || []).push(s)
      return acc
    }, {})
  const groups = Object.keys(byYear)
    .sort((a, b) => b.localeCompare(a))
    .map(year => ({ key: year, year, rows: byYear[year].sort(byStart) }))
  return yearly.length ? [...groups, { key: YEARLY_GROUP, year: null, rows: yearly }] : groups
}

// Same month and day next year; Feb 29 clamps to Feb 28. String arithmetic, so no timezone can move the day.
export const shiftOneYear = iso => {
  const [year, month, day] = iso.split('-').map(Number)
  const next = year + 1
  const lastDay = new Date(Date.UTC(next, month, 0)).getUTCDate()
  const clamped = Math.min(day, lastDay)
  return `${next}-${String(month).padStart(2, '0')}-${String(clamped).padStart(2, '0')}`
}

export const formatDate = (iso, lang) => {
  if (!iso) return ''
  const date = new Date(`${iso}T00:00:00`)
  return new Intl.DateTimeFormat(LOCALES[lang] || LOCALES.es, { day: 'numeric', month: 'short', year: 'numeric' }).format(date)
}

export const formatTimestamp = (iso, lang) => {
  if (!iso) return ''
  return new Intl.DateTimeFormat(LOCALES[lang] || LOCALES.es, { day: 'numeric', month: 'short', year: 'numeric' }).format(new Date(iso))
}

export const getErrorMessage = error => error?.response?.data?.error || null

export const isUnprocessable = error => error?.response?.status === 422
